import api from 'axios'
import router from '../../router'

const state = {
  accessToken: localStorage.getItem('access_token') ? localStorage.getItem('access_token') : null,
  registrationData: {}
}

const actions = {
  validateAccessToken ({ commit, dispatch }) {
    const accessToken = localStorage.getItem('access_token')

    return new Promise((resolve, reject) => {
      if (!accessToken) {
        commit('INVALID_ACCESS_TOKEN')
        return reject(new Error('No access token stored!'))
      }

      api.get('/me')
        .then(
          response => {
            commit('SET_ACCESS_TOKEN', accessToken)
            commit('SET_USER', response.data)
            dispatch('getLedgers')
            dispatch('subscribeToUserPrivateChannel', response.data.id)
            resolve(response)
          }
        )
        .catch(
          error => {
            commit('INVALID_ACCESS_TOKEN')
            commit('UNSET_USER')
            router.replace('/login')
            error.response ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  login ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/auth/login', data)
        .then(
          response => {
            const accessToken = response.data.token
            commit('SET_ACCESS_TOKEN', accessToken)
            commit('SET_USER', response.data.user)
            dispatch('getLedgers')
            dispatch('subscribeToUserPrivateChannel', response.data.user.id)
            resolve()
          }
        )
        .catch(
          error => {
            error.response ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  logout ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.post('/auth/logout')
        .then(
          response => {
            commit('LOGOUT')
            commit('UNSET_USER')
            commit('UNSET_LEDGER_LIST')
            commit('UNSET_UPCOMING_EXPENSES')
            commit('UNSET_LEDGER_STATS')
            resolve()
          }
        )
        .catch(
          error => {
            commit('LOGOUT')
            commit('UNSET_USER')
            commit('UNSET_LEDGER_LIST')
            commit('UNSET_UPCOMING_EXPENSES')
            commit('UNSET_LEDGER_STATS')
            router.replace('/login')
            reject(error)
          }
        )
      /**
       * Remove the sensitive (GDPR) data from cache
       */
      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          if (cacheName.includes('-runtime-')) {
            caches.delete(cacheName)
          }
        })
      })
    })
  },
  register ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('/auth/register', data)
        .then(
          response => {
            const accessToken = response.data.token
            commit('SET_ACCESS_TOKEN', accessToken)
            commit('SET_USER', response.data.user)
            resolve()
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  resetPasswordRequest ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('auth/password/reset/request', data)
        .then(
          response => {
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  resetPassword ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.post('auth/password/reset', data)
        .then(
          response => {
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  subscribeToUserPrivateChannel ({ commit, dispatch }, userId) {
    let channel = window.pusher.subscribe('private-user.' + userId)
    channel.bind('ledger.shared', function (data) {
      dispatch('getLedgers')
    })
    channel.bind('ledger.unshared', function (data) {
      dispatch('getLedgers')
    })
    channel.bind('account.passwordChange', function (data) {
      commit('LOGOUT')
      commit('UNSET_USER')
      router.replace('/login')
    })
  }
}

const mutations = {
  SET_ACCESS_TOKEN (state, token) {
    localStorage.setItem('access_token', token)
    /*
    This is important to set up because if the app initial state is guest
    then the local storage access token is null and this header setup in the main.js needs to be updated
     */
    api.defaults.headers.common['Authorization'] = 'Bearer ' + token
    window.pusher.config.auth.headers.Authorization = 'Bearer ' + token
    state.accessToken = token
  },
  INVALID_ACCESS_TOKEN (state) {
    state.accessToken = null
    localStorage.removeItem('access_token')
  },
  LOGOUT (state) {
    state.accessToken = null
    localStorage.removeItem('access_token')
    localStorage.removeItem('route_path')
    localStorage.removeItem('subscription_billing_details')
  },
  SET_REGISTRATION_DATA (state, data) {
    state.registrationData = data
  },
  UNSET_REGISTRATION_DATA (state) {
    state.registrationData = {}
  }
}

export default {
  state,
  actions,
  mutations
}
